import React, { useContext } from "react";
import { GlobalDataContext } from "../../context/context";
import { ButtonContent } from "../global/boton/ButtonContent";
import { VscDebugBreakpointData } from 'react-icons/vsc'

import imgfond from '../../assets/image/bbb.png'
import imgDefault from '../../assets/image/placeholder.png'



function BlockFour({ image1, title, text, listAbout, listServices, sloganPrincipal }) {
    const { rpdata } = useContext(GlobalDataContext);
    return (
        <div className="w-full h-auto bg1 relative">
            <div className='w-[80px] h-[80px] absolute top-0 left-1/2 transform hover:scale-105 duration-300 ease-in-out md:block hidden'>
                <img src="https://firebasestorage.googleapis.com/v0/b/imagenes-de-stock-y-redes.appspot.com/o/bubble-1.png?alt=media&token=54a58d49-8432-4ae9-ae1c-22edb0761a12&_gl=1*pinu31*_ga*ODgwNTY3MjU1LjE2NjEwMTIyMDI.*_ga_CW55HF8NVT*MTY4NjE2NDcwNS41NS4xLjE2ODYxNjQ3MzcuMC4wLjA." alt="burble"
                    className='w-full h-full object-contain'
                />
            </div>
            <div className='w-[150px] h-[150px] absolute top-36 left-6 transform hover:scale-105 duration-300 ease-in-out md:block hidden'>
                <img src="https://firebasestorage.googleapis.com/v0/b/imagenes-de-stock-y-redes.appspot.com/o/bubble-1.png?alt=media&token=54a58d49-8432-4ae9-ae1c-22edb0761a12&_gl=1*pinu31*_ga*ODgwNTY3MjU1LjE2NjEwMTIyMDI.*_ga_CW55HF8NVT*MTY4NjE2NDcwNS41NS4xLjE2ODYxNjQ3MzcuMC4wLjA." alt="burble"
                    className='w-full h-full object-contain'
                />
            </div>
            <div className='w-[180px] h-[180px] absolute bottom-36 right-6 transform hover:scale-105 duration-300 ease-in-out md:block hidden'>
                <img src="https://firebasestorage.googleapis.com/v0/b/imagenes-de-stock-y-redes.appspot.com/o/bubble-1.png?alt=media&token=54a58d49-8432-4ae9-ae1c-22edb0761a12&_gl=1*pinu31*_ga*ODgwNTY3MjU1LjE2NjEwMTIyMDI.*_ga_CW55HF8NVT*MTY4NjE2NDcwNS41NS4xLjE2ODYxNjQ3MzcuMC4wLjA." alt="burble"
                    className='w-full h-full object-contain'
                />
            </div>
            <section className="w-4/5 mx-auto md:py-32 py-10">
                <div className="md:flex md:flex-row flex flex-col md:p-0 px-2 content-reverse">
                    <div className="md:w-[50%] relative">
                        <div
                            className="md:w-full md:md:h-[600px] w-[250px] h-[250px] bg-cover bg-center relative"
                            style={{ backgroundImage: `url("${imgfond}")` }}
                        >
                            <img
                                src={image1 ? image1 : imgDefault}
                                alt="notimg"
                                className="w-[85%] h-[85%] absolute top-10 left-10 object-cover rounded-tl-[25%] rounded-tr-[35%] rounded-br-[10%] rounded-bl-[35%]"
                            />
                        </div>
                    </div>

                    <div className="md:w-[50%] py-4 md:px-8 px-3 self-center md:text-start text-center" data-aos="fade-up" data-aos-duration="900">
                        {
                            sloganPrincipal ?
                                rpdata?.dbPrincipal?.licensed ?
                                    <h2 className='pb-3 capitalize text-white'>
                                        {rpdata?.dbPrincipal?.licensed}
                                    </h2>
                                    : <h3 className='pb-10 capitalize text-white'>
                                        {
                                            rpdata?.dbPrincipal?.exprYears ?
                                                `we have ${rpdata?.dbPrincipal?.exprYears} years of experience`
                                                : 'we have many years of experience'
                                        }
                                    </h3>
                                :
                                <h2 className="separator-about capitalize text-white">
                                    {
                                        title ? title :
                                            <span className='lowercase text-[18px]'>
                                                {`default title={'frase'}`} o
                                                {` agregar licencia o años de experienceias sloganPrincipal={true}`}
                                            </span>
                                    }
                                </h2>
                        }
                        <p className="pb-4 text-white">
                            {
                                text ? text :
                                    <span>{`para agregar el texto -> text={'description'}`}
                                        <br />{'para agregar lista de about -> listsAbout={true}'}
                                        <br />{'para agregar lista de servicios -> listsServices={true}'}
                                    </span>
                            }
                        </p>
                        {
                            listAbout ?
                                <ul className='grid grid-cols-1 md:grid-cols-2 pb-5'>
                                    {
                                        rpdata?.dbAbout?.[0].list.length > 1 ?
                                            rpdata?.dbAbout?.[0].list.map((item, index) => {
                                                return (

                                                    <li key={index} className="py-2 flex items-center">
                                                        <VscDebugBreakpointData />
                                                        <span className="pl-2">{item}</span>
                                                    </li>
                                                )
                                            })
                                            : null
                                    }
                                </ul>
                                : null
                        }
                        {
                            listServices ?
                                <ul className="grid grid-cols-1 md:grid-cols-2 pb-5">
                                    {rpdata?.dbServices?.slice(0, 6).map((item, index) => {
                                        return (
                                            <li key={index} className="py-1 flex items-center">
                                                <VscDebugBreakpointData />
                                                <span>{item.name}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                                : null
                        }

                        <ButtonContent btnStyle='three' />

                        <div className="w-full">
                            <span className="separator-about"></span>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default BlockFour;
